import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useInsightBotStore = create(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setUser: (user) => set({ user }),
      clearAuth: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    { name: 'insight-bot-auth' }
  )
);

export default useInsightBotStore;
